<template lang="pug">
.features-container
  h2.title(:class="$mq") Fonctionnalités
  .feature-content(:class="$mq")
    img.image(src="@/assets/img/cyclogramme-symptothermie-moonly-app-medium.png" alt="Page du graph sur l'application mobile Moonly")
    .feature.save(:class="$mq")
      h3.num 1
      h3.desc
        .subtitle(:class="$mq") Enregistre tes données quotidiennes
        .info(:class="$mq") Température, glaire cervicale (pertes blanches), règles, col de l'utérus, syndrôme prémenstruel (SPM), perturbateurs...
    .feature.calcul(:class="$mq")
      h3.num 2
      h3.desc
        .subtitle(:class="$mq") Règles de la méthode symptothermique
        .info(:class="$mq") Calcul automatique ou manuel des indices combinés
    .feature.share(:class="$mq")
      h3.num 3
      h3.desc
        .subtitle(:class="$mq") Partage tes données
        .info(:class="$mq") Avec ta·on partenaire adoré·e
</template>

<script>
export default {
  name: 'Features'
}
</script>

<style lang="scss" scoped>
@use '@/styles/text';
@use '@/styles/colors';

.title {
  @include text.title;
}

.feature-content {
  display: grid;

  &.phone,
  &.tablet-portrait {
    grid-template-columns: auto 300px auto;
    grid-template-rows: auto repeat(3, auto);
    row-gap: 20px;
    grid-template-areas:
      ".      img    ."
      "save   save   save"
      "calcul calcul calcul"
      "share  share  share";
    .image {
      max-height: 800px;
      min-height: initial;
      justify-self: center;
      margin: {
        bottom: 30px;
      }
    }
  }

  &.tablet-landscape,
  &.desktop,
  &.large-desktop {
    // padding: {
    //   top: 7%;
    //   bottom: 10%;
    // }
    grid-template-rows: auto repeat(3, 120px) auto;
    grid-template-areas:
      "img ."
      "img save"
      "img calcul"
      "img share"
      "img .";
    .image {
      height: 70vh;
    }
  }

  &.tablet-landscape {
    grid-template-columns: 300px auto;
    column-gap: 50px;
  }

  &.desktop,
  &.large-desktop {
    grid-template-columns: 400px auto;
    column-gap: 60px;
    row-gap: 30px;
  }

  justify-content: center;
  align-items: center;

  .image {
    grid-area: img;
    height: auto;
    max-height: 600px;
    min-height: 500px;
    max-width: 80vw;
    justify-self: right;
  }

  .feature {
    display: grid;
    justify-content: center;
    align-items: center;
    column-gap: 30px;

    &.phone {
      grid-template-columns: 50px 60%;
      .num {
        font-size: 50px;
      }
    }
    &.tablet-portrait {
      grid-template-columns: 50px 500px;
      .num {
        font-size: 55px;
      }
    }

    &.tablet-landscape {
      grid-template-columns: 50px 450px;
    }

    &.desktop,
    &.large-desktop {
      grid-template-columns: 100px 500px;
      column-gap: 60px;
    }

    .num {
      font-size: 70px;
      color: colors.$light-purple-gradient;
      text-align: right;
    }

    .desc {
      .subtitle {
        @include text.normal;
        text-align: left;
        font-weight: 600;
      }
      .info {
        @include text.small;
        text-align: left;
      }
    }
  }

  .save {
    grid-area: save;
  }

  .calcul {
    grid-area: calcul;
  }

  .share {
    grid-area: share;
  }
}
</style>
